import { useState, useEffect } from 'react';
function generateDeviceId(): string {
    const nav = window.navigator;
    const screen = window.screen;
    const deviceInfo = [
        nav.userAgent,
        screen.width,
        screen.height,
        screen.colorDepth,
        nav.language,
        nav.hardwareConcurrency,
        new Date().getTimezoneOffset()
    ].join('|');

    // Simple hash function
    function simpleHash(str: string): number {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash; // Convert to 32-bit integer
        }
        return Math.abs(hash);
    }

    // Generate a hash and convert to base36
    const hash = simpleHash(deviceInfo).toString(36);

    // Ensure the result is 32 characters long
    return hash.padStart(32, '0').slice(-32);
}


export function useDeviceId() {
    const [deviceId, setDeviceId] = useState<string | null>(null);

    useEffect(() => {
        const storedId = localStorage.getItem('deviceId');
        if (storedId) {
            setDeviceId(storedId);
        } else {
            const newId = generateDeviceId();
            localStorage.setItem('deviceId', newId);
            setDeviceId(newId);
        }
    }, []);

    return { deviceId };
}